import * as z from "zod/v4";

export const submitBackInStockForm = {
  name: "submitBackInStockForm" as const,
  input: z.object({
    email: z.email().optional(),
    phone: z.string().optional(),
    productId: z.string(),
    variantId: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
